import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { media } from '@prisjakt/ui-base';
import { AppContext } from '@prisjakt/ui-app-context';
import Breadcrumb from '@prisjakt/ui-breadcrumb';
import PageContent from '../../components/page-content';
import PageHeader from '../../components/page-header';
import { CategoryList } from '../../components/category-list';

const icon = 'https://cdn.pji.nu/g/cat/192/tjanster.png';

const Gutter = styled.div`
  padding-left: 0.8rem;
  padding-right: 0.8rem;
`;

const DescriptionText = styled.div`
  max-width: 500px;
  font-size: 14px;
  color: ${p => p.theme.text.secondary};

  ${media.smallOnly`
    font-size: 13px;
  `}
`;

const Services = ({ data }) => {
  const { t } = useContext(AppContext);

  const services = data.categoryTree[0].children.map(child => ({
    ...child,
    logo: {
      192: child.logo,
    },
  }));

  return (
    <PageContent withAds headerHeight={0} bottomPlacements={[]}>
      <Breadcrumb
        homeText={t('common', 'breadcrumb.home')}
        path={[{ name: t('category', 'service-list.title') }]}
      />
      <PageHeader
        media={
          <img
            width={100}
            alt={t('category', 'service-list.title')}
            src={icon}
          />
        }
        title={t('category', 'service-list.title')}
      >
        <DescriptionText>
          {t('category', 'service-list.description')}
        </DescriptionText>
      </PageHeader>
      <Gutter>
        <CategoryList categories={services} withAds />
      </Gutter>
    </PageContent>
  );
};

Services.propTypes = {
  data: PropTypes.object.isRequired,
};

export default memo(Services);
